import styled from 'styled-components';

export const PageFeatureContainer = styled.div`
  padding: 1.25rem 2.5rem;
`;
